import { render, staticRenderFns } from "./followupStepForm.vue?vue&type=template&id=992002f4"
import script from "./followupStepForm.vue?vue&type=script&lang=js"
export * from "./followupStepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports